var _g, _g2, _g3, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 725,
    viewBox: "0 0 1440 725",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_906_471)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 956.884,
    y: 714.744,
    width: 473.293,
    height: 519.879,
    rx: 236.647,
    transform: "rotate(145.17 956.884 714.744)",
    fill: "url(#paint0_linear_906_471)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_906_471)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 844.197,
    y: 1011.2,
    width: 561.199,
    height: 411.069,
    rx: 205.535,
    transform: "rotate(-122.525 844.197 1011.2)",
    fill: "url(#paint1_linear_906_471)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_906_471)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 796.855,
    y: 681.928,
    width: 271.645,
    height: 298.383,
    rx: 135.823,
    transform: "rotate(145.17 796.855 681.928)",
    fill: "url(#paint2_linear_906_471)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.902 631.846C287.754 654.957 304.132 674.267 328.792 689.388C353.454 704.51 386.382 715.431 425.284 721.761C503.087 734.42 604.719 728.709 711.732 701.609C818.746 674.51 910.848 631.162 973.248 582.998C1004.45 558.916 1028.21 533.64 1042.7 508.602C1057.19 483.566 1062.41 458.789 1056.55 435.678C1050.7 412.567 1034.32 393.258 1009.66 378.136C985.002 363.014 952.074 352.094 913.172 345.764C835.369 333.104 733.737 338.816 626.723 365.915C519.71 393.014 427.608 436.363 365.208 484.526C334.008 508.609 310.246 533.885 295.754 558.922C281.262 583.958 276.05 608.735 281.902 631.846Z",
    stroke: "url(#paint3_linear_906_471)",
    strokeWidth: 0.673735
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.322 676.309C114.838 709.937 138.665 738.021 174.518 760.006C210.373 781.991 258.236 797.863 314.77 807.062C427.837 825.459 575.523 817.158 731.022 777.78C886.52 738.403 1020.36 675.413 1111.04 605.419C1156.38 570.422 1190.92 533.683 1211.99 497.283C1233.06 460.884 1240.65 424.843 1232.13 391.215C1223.62 357.588 1199.79 329.503 1163.94 307.518C1128.08 285.533 1080.22 269.662 1023.69 260.463C910.619 242.065 762.933 250.367 607.434 289.744C451.936 329.121 318.098 392.111 227.415 462.105C182.073 497.103 147.533 533.841 126.464 570.242C105.395 606.64 97.8064 642.681 106.322 676.309Z",
    stroke: "url(#paint4_linear_906_471)",
    strokeWidth: 0.673735
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.326 730.412C-95.5693 776.837 -62.6763 815.6 -13.2041 845.935C36.27 876.272 102.305 898.168 180.295 910.858C336.272 936.238 539.997 924.784 754.493 870.467C968.989 816.149 1153.61 729.26 1278.71 632.702C1341.26 584.423 1388.91 533.737 1417.99 483.51C1447.06 433.284 1457.54 383.539 1445.78 337.113C1434.03 290.688 1401.13 251.926 1351.66 221.59C1302.19 191.254 1236.15 169.358 1158.16 156.668C1002.18 131.288 798.459 142.741 583.963 197.059C369.468 251.376 184.845 338.266 59.7468 434.823C-2.80295 483.103 -50.4581 533.789 -79.5308 584.016C-108.602 634.241 -119.082 683.987 -107.326 730.412Z",
    stroke: "url(#paint5_linear_906_471)",
    strokeWidth: 0.673735
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_906_471",
    x: 164.199,
    y: 180.743,
    width: 899.942,
    height: 911.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_906_471"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_906_471",
    x: 420.703,
    y: 195.246,
    width: 891.842,
    height: 937.704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_906_471"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_906_471",
    x: 256.685,
    y: 290.229,
    width: 686.94,
    height: 693.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_906_471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_471",
    x1: 1442.93,
    y1: 1106.14,
    x2: 847.012,
    y2: 1284.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25F5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A3F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_906_471",
    x1: 1124.8,
    y1: 1011.2,
    x2: 1124.8,
    y2: 1422.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF375F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_906_471",
    x1: 1075.82,
    y1: 906.566,
    x2: 733.794,
    y2: 1008.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A059FD",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_906_471",
    x1: 1029.73,
    y1: 422.294,
    x2: 358.647,
    y2: 700.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_906_471",
    x1: 1193.01,
    y1: 371.807,
    x2: 217.976,
    y2: 776.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_906_471",
    x1: 1391.69,
    y1: 310.373,
    x2: 46.8046,
    y2: 868.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightFooter);
export default __webpack_public_path__ + "static/media/lightFooter.169dcffff7985251f666e590e07fbb13.svg";
export { ForwardRef as ReactComponent };